import * as $runtime from "../runtime.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
const $Loading = (_1, _2) => ({tag: "MkLoading", _1, _2});
const $LoadingStatus = tag => ({tag});
const MkLoadingIsSymbol = {reflectSymbol: () => "MkLoading"};
const Loading = /* #__PURE__ */ $LoadingStatus("Loading");
const Loaded = /* #__PURE__ */ $LoadingStatus("Loaded");
const MkLoading = value0 => value1 => $Loading(value0, value1);
const semigroupLoadingStatus = {
  append: v => v1 => {
    if (v.tag === "Loading") { return Loading; }
    if (v1.tag === "Loading") { return Loading; }
    if (v.tag === "Loaded") {
      if (v1.tag === "Loaded") { return Loaded; }
      $runtime.fail();
    }
    $runtime.fail();
  }
};
const monoidLoadingStatus = {mempty: Loaded, Semigroup0: () => semigroupLoadingStatus};
const genericLoadingStatus_ = {
  to: x => {
    if (x.tag === "Inl") { return Loading; }
    if (x.tag === "Inr") { return Loaded; }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "Loading") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Loaded") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments); }
    $runtime.fail();
  }
};
const showLoadingStatus = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Loading"});
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)({reflectSymbol: () => "Loaded"});
    return x => {
      if (x.tag === "Loading") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "Loaded") { return $1["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      $runtime.fail();
    };
  })()
};
const eqLoadingStatus = {
  eq: x => y => {
    if (x.tag === "Loading") { return y.tag === "Loading"; }
    if (x.tag === "Loaded") { return y.tag === "Loaded"; }
    return false;
  }
};
const unLoading = v => v._2;
const semigroupLoading = dictSemigroup => (
  {
    append: v => v1 => $Loading(
      (() => {
        if (v._1.tag === "Loading") { return Loading; }
        if (v1._1.tag === "Loading") { return Loading; }
        if (v._1.tag === "Loaded") {
          if (v1._1.tag === "Loaded") { return Loaded; }
          $runtime.fail();
        }
        $runtime.fail();
      })(),
      dictSemigroup.append(v._2)(v1._2)
    )
  }
);
const monoidLoading = dictMonoid => {
  const semigroupLoading1 = semigroupLoading(dictMonoid.Semigroup0());
  return {mempty: $Loading(Loaded, dictMonoid.mempty), Semigroup0: () => semigroupLoading1};
};
const loading = /* #__PURE__ */ MkLoading(Loading);
const loaded = /* #__PURE__ */ MkLoading(Loaded);
const genericLoading = {to: x => $Loading(x._1, x._2), from: x => Data$dGeneric$dRep.$Product(x._1, x._2)};
const genericShow = dictGenericShow => x => dictGenericShow["genericShow'"](Data$dGeneric$dRep.$Product(x._1, x._2));
const showLoading = dictShow => (
  {
    show: genericShow(Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsProduct({genericShowArgs: v => [showLoadingStatus.show(v)]})({
      genericShowArgs: v => [dictShow.show(v)]
    }))(MkLoadingIsSymbol))
  }
);
const functorLoading = {map: f => m => $Loading(m._1, f(m._2))};
export {
  $Loading,
  $LoadingStatus,
  Loaded,
  Loading,
  MkLoading,
  MkLoadingIsSymbol,
  eqLoadingStatus,
  functorLoading,
  genericLoading,
  genericLoadingStatus_,
  genericShow,
  loaded,
  loading,
  monoidLoading,
  monoidLoadingStatus,
  semigroupLoading,
  semigroupLoadingStatus,
  showLoading,
  showLoadingStatus,
  unLoading
};
